@let unread = unreadCount();
@let connState = connectionState();
@let mess = messages();

<button
  class="relative mx-2 notification-center text-layout-sidenav-text dark:text-layout-dark-sidenav-text"
  mat-ripple
  mat-button
  [matMenuTriggerFor]="notificationCenter"
>
  <notifications-notification-bell></notifications-notification-bell>
</button>
<mat-menu #notificationCenter="matMenu" class="notification-center-menu">
  @if (connState === connectedState) {
    <div
      class="flex flex-col min-w-[200px] max-w-[500px] origin-top-right divide-y focus:outline-none text-layout-sidenav-text dark:text-layout-dark-sidenav-text"
    >
      <div class="px-4 py-2" role="none">
        <div class="font-medium text-center">
          {{ 'notification.PLURAL' | transloco }}
        </div>
      </div>
      <div class="flex-1 overflow-y-auto max-h-[60vh]">
        @if (mess.length === 0) {
          <div class="py-4 text-center">
            {{ 'notification.EMPTY' | transloco }}
          </div>
        }
        <ul role="list" class="divide-y divide-gray-100 dark:divide-gray-700">
          @for (item of mess; track item.id) {
            <li class="flex justify-between">
              <notifications-notification-host
                [notification]="item"
              ></notifications-notification-host>
            </li>
          }
        </ul>
      </div>
      <div
        class="flex flex-row self-center justify-center w-full px-4 py-2 text-center cursor-pointer text-primary-color"
        [ngClass]="{ hidden: unread === 0 }"
        (click)="setAllRead($event)"
      >
        {{ 'notification.MARK_ALL_READ' | transloco }}
      </div>
    </div>
  } @else {
    <div class="disconnected">
      {{ 'notification.DISCONNECTED' | transloco }}
    </div>
  }
  <ng-template #disconnected
    ><div class="disconnected">
      {{ 'notification.DISCONNECTED' | transloco }}
    </div></ng-template
  >
</mat-menu>
